import { reduce } from "et3-type-guards";
import ET3Div from "../../../../core/et3-div";
import { withLiteObserverAndTheme } from "../../../../core/et3-enhanced-render";
import Et3Table from "../../../../core/et3-table";
import i18n from "../../../../constants/i18n";
import {
  CURRENT_RECEIPT_MONTH_HEADERS,
  PREVIOUS_RECEIPT_MONTH_HEADERS
} from "../../../../constants/table-custom-headers/CSR";
import Et3Margin from "../../../../core/et3-ui/ET3Margin";
import CSRReceiptStore from "../../../../stores/csr-store/csr-receipt-event-count";
import { currentMonthCSRArray } from "../../../../helpers/et3-receipt-compensation-and-calculation/csr-receipt-helpers";

const MyCSRReceiptEventCountData = withLiteObserverAndTheme(() => {
  const currentMonthCSRReceipt = reduce(() => currentMonthCSRArray(), []);
  const csrCompensationPreviousMonths = reduce(
    () => CSRReceiptStore().adminFinalReceipts.get(),
    []
  );

  return (
    <ET3Div
      isScrollable={false}
      isExtendable={true}
      fDirection="column"
      justifyContent="center"
      alignItems="center"
      withShadow={false}
      width={1500}
      height={300}
      color={""}
      style={{}}
      onClick={() => {}}
    >
      <Et3Table
        columns={CURRENT_RECEIPT_MONTH_HEADERS}
        rows={currentMonthCSRReceipt}
        title={i18n.get("CURRENT_RECEIPT_MONTH")}
        shouldBeFlagged={false}
        titleKey={"CURRENT_RECEIPT_MONTH"}
      />
      <Et3Margin top={30} left={0} right={0} bottom={0} />
      <Et3Table
        columns={PREVIOUS_RECEIPT_MONTH_HEADERS}
        rows={csrCompensationPreviousMonths}
        title={i18n.get("PREVIOUS_RECEIPT_MONTH")}
        shouldBeFlagged={false}
        titleKey={"PREVIOUS_RECEIPTS_MONTHS"}
      />
    </ET3Div>
  );
});

export default MyCSRReceiptEventCountData;
